const translationContext = "admin.brokers.enums";
export default [
  { value: "MONTHLY", key: `${translationContext}.monthly` },
  { value: "YEARLY", key: `${translationContext}.yearly` },
  { value: "ONE_TIME", key: `${translationContext}.oneTime` },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/compensationTypeOptions.js